export default "__VITE_ASSET__3e1ade80__"